import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { statsData } from '@/mocks/sportsData';

const milestones = [
  { year: '2018', title: '平台创立', description: '九游体育正式成立，以专业赛事数据服务切入体育市场，首年即获得百万用户认可。' },
  { year: '2019', title: '赛事直播上线', description: '推出赛事直播功能，覆盖足球、篮球两大核心品类，全年直播赛事超过3000场。' },
  { year: '2020', title: '用户突破千万', description: '平台注册用户突破1000万，月活跃用户达到500万，成为国内领先的体育平台之一。' },
  { year: '2021', title: 'AI数据分析发布', description: '上线自研AI赛事分析系统，覆盖50万+数据维度，为用户提供专业的比赛预测和深度洞察。' },
  { year: '2022', title: '电竞频道上线', description: '正式开拓电竞业务，覆盖英雄联盟、DOTA2等顶级赛事，电竞用户快速增长。' },
  { year: '2023', title: '全球化布局', description: '启动国际化战略，与全球200+体育机构和赛事组织建立合作关系，覆盖更多国际赛事。' },
  { year: '2024', title: '用户突破3000万', description: '月活跃用户突破3000万，平台赛事直播累计超过12800场，稳居行业第一梯队。' },
  { year: '2025', title: '网球频道全面升级', description: '获得四大满贯赛事直播权，网球频道全面升级，为用户提供顶级的网球观赛体验。' },
  { year: '2026', title: '持续创新', description: '持续优化产品体验，推出多项创新功能，致力于为每一位体育爱好者带来极致的体育娱乐体验。' },
];

const honors = [
  '2025年度最佳体育平台（中国体育产业协会）',
  '2024年十大创新互联网企业（工信部评选）',
  '2023年最佳用户体验奖（中国互联网协会）',
  '2022年体育科技先锋企业（国家体育总局）',
  '2021年最具投资价值体育科技公司（清科集团）',
  '2020年年度新锐体育媒体（中国传媒协会）',
];

const faqData = [
  {
    question: '九游体育提供哪些体育项目的直播？',
    answer: '九游体育目前覆盖足球、篮球、网球、电竞等多项全球顶级体育赛事直播，包括英超、西甲、欧冠、NBA、CBA、ATP、WTA以及主流电竞赛事等。我们持续拓展赛事版权，力求为用户提供最全面的体育直播体验。',
  },
  {
    question: '如何在九游体育观看赛事直播？',
    answer: '您可以通过九游体育官网或下载九游体育APP观看赛事直播。在首页或分类页面点击赛事直播卡片即可进入直播间。注册登录后可享受高清画质和实时数据叠加等高级功能。',
  },
  {
    question: '九游体育的数据分析功能如何使用？',
    answer: '九游体育的数据分析功能集成在赛事直播页面和数据分析专区中。您可以在观看比赛时查看实时数据，包括球队/球员统计、历史交锋记录、战术分析等。我们还提供赛前预测和赛后复盘分析，帮助您深入了解比赛。',
  },
  {
    question: '九游体育是免费的吗？',
    answer: '九游体育提供免费的基础服务，包括赛事资讯浏览、部分赛事直播和基础数据分析功能。同时我们提供高级会员服务，会员可享受高清直播、独家深度分析、去广告等增值服务。',
  },
  {
    question: '如何成为九游体育的合作伙伴？',
    answer: '九游体育欢迎各类合作。如果您是体育机构、赛事组织方、品牌方或内容创作者，欢迎通过联系我们页面的信息与我们取得联系。我们的商务团队会在收到信息后的3个工作日内与您对接。',
  },
];

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于九游体育 - 专业体育赛事平台 | 品牌故事与联系方式"
        description="了解九游体育的品牌故事、发展历程、行业荣誉和联系方式。九游体育是专业体育赛事平台，为全球体育爱好者提供赛事直播、资讯、数据分析和互动社区服务。"
        keywords="九游体育,关于九游体育,九游体育官网,体育平台,品牌介绍,联系方式"
        canonicalUrl="https://www.jiuyou-sports.com/about"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于九游体育',
            description: '了解九游体育的品牌故事、发展历程和联系方式。',
            url: 'https://www.jiuyou-sports.com/about',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.jiuyou-sports.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 md:pt-24">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
                <Link to="/" className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-foreground-800 font-medium">关于我们</span>
              </nav>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                关于九游体育
              </h1>
              <p className="mt-2 text-sm text-foreground-500">了解我们的品牌故事、发展历程与核心价值观</p>
            </div>
          </div>

          <section className="py-14 md:py-20">
            <div className="mx-auto max-w-7xl px-4 md:px-6">
              <div className="max-w-3xl mx-auto text-center mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  品牌介绍
                </h2>
                <p className="mt-4 text-foreground-600 leading-relaxed">
                  九游体育成立于2018年，是国内领先的专业体育赛事平台。我们致力于为全球体育爱好者提供全方位的体育娱乐体验——从赛事直播到数据分析，从新闻资讯到互动社区，九游体育始终以用户为中心，不断创新产品和服务。
                </p>
                <p className="mt-3 text-foreground-600 leading-relaxed">
                  经过多年的发展，九游体育已经成长为覆盖足球、篮球、网球、电竞等多项运动的综合性体育平台，月活跃用户超过3200万，累计直播赛事超过12800场。我们与全球200多家体育机构和赛事组织建立了深度合作关系，为用户带来最前沿、最全面的体育内容。
                </p>
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-14">
                {statsData.map((stat) => (
                  <div
                    key={stat.label}
                    className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                      <i className={`${stat.icon} text-xl`}></i>
                    </div>
                    <p className="font-heading text-2xl font-bold text-primary-600">{stat.value}</p>
                    <p className="text-sm text-foreground-600 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="mx-auto max-w-7xl px-4 md:px-6">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  发展历程
                </h2>
                <p className="mt-2 text-sm text-foreground-500">从创立到领先，每一步都踏实前行</p>
              </div>

              <div className="max-w-3xl mx-auto relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 -translate-x-1/2 hidden md:block"></div>
                <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-background-300 md:hidden"></div>

                <div className="flex flex-col gap-8">
                  {milestones.map((item, index) => (
                    <div
                      key={item.year}
                      className={`relative pl-10 md:pl-0 ${
                        index % 2 === 0 ? 'md:pr-[50%] md:text-right' : 'md:pl-[50%] md:text-left'
                      }`}
                    >
                      <div className="absolute left-0 md:left-1/2 top-1 w-8 h-8 rounded-full bg-accent-500 text-background-50 flex items-center justify-center -translate-x-1/2 z-10">
                        <span className="text-xs font-bold">{String(index + 1)}</span>
                      </div>
                      <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-2">
                          {item.year}
                        </span>
                        <h3 className="font-semibold text-foreground-900">{item.title}</h3>
                        <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20">
            <div className="mx-auto max-w-7xl px-4 md:px-6">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  荣誉口碑
                </h2>
                <p className="mt-2 text-sm text-foreground-500">行业认可，用户信赖</p>
              </div>

              <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4">
                {honors.map((honor, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70"
                  >
                    <div className="flex-shrink-0 w-9 h-9 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center mt-0.5">
                      <i className="ri-award-line"></i>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{honor}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="mx-auto max-w-7xl px-4 md:px-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
                    联系我们
                  </h2>
                  <div className="space-y-5">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <h3 className="font-semibold text-foreground-800 text-sm">电子邮箱</h3>
                        <p className="text-sm text-foreground-600 mt-1">contact@jiuyou-sports.com</p>
                        <p className="text-sm text-foreground-600">business@jiuyou-sports.com（商务合作）</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                        <i className="ri-phone-line text-lg"></i>
                      </div>
                      <div>
                        <h3 className="font-semibold text-foreground-800 text-sm">客服热线</h3>
                        <p className="text-sm text-foreground-600 mt-1">400-888-9999</p>
                        <p className="text-xs text-foreground-500">工作时间：周一至周日 9:00 - 21:00</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                        <i className="ri-map-pin-line text-lg"></i>
                      </div>
                      <div>
                        <h3 className="font-semibold text-foreground-800 text-sm">公司地址</h3>
                        <p className="text-sm text-foreground-600 mt-1">北京市朝阳区体育中心路88号</p>
                        <p className="text-sm text-foreground-600">九游体育大厦 15层</p>
                        <p className="text-xs text-foreground-500">邮编：100020</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
                  <h3 className="font-semibold text-lg text-foreground-900 mb-2">常见问题</h3>
                  <p className="text-sm text-foreground-500 mb-6">以下是用户最常咨询的问题，快速了解九游体育</p>
                  <div className="space-y-4">
                    {faqData.map((faq, index) => (
                      <details key={index} className="group">
                        <summary className="flex items-center justify-between cursor-pointer py-3 border-b border-background-200/70">
                          <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                          <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform duration-200 flex-shrink-0"></i>
                        </summary>
                        <p className="pt-3 pb-1 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                      </details>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}